import { prepareCommunityBody } from './utils'
import { api } from '@/app'
import { AchievementLevel, Chapter, Post } from '@/types'
import { WebInputFile } from '@codeleap/common'
import { AppStatus } from '@/redux'
import { VideoCache } from '@/utils'
import { useMutation } from '@tanstack/react-query'
import { achievementsStore } from '@/stores'

export type PostContent = {
  image?: WebInputFile
  title?: string
  description?: string
  video?: WebInputFile
  lesson?: Chapter['id']
}

const postToCommunity = async (params: PostContent) => {
  const body = await prepareCommunityBody(params)

  const response = await api.post<Post>(`community/post/`, body, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })

  const videoPath = params?.video?.preview

  if (videoPath) {
    // Since transcoding hasn't completed yet, we load the local video in the feed
    response.data.video.url = videoPath
    VideoCache.set(response.data.feed_item, videoPath)
  }

  achievementsStore.verifyProgress(response?.data?.achievement_progress as any)

  return response.data
}

export function usePostToCommunity() {
  const mut = useMutation({
    mutationKey: ['postToCommunity'],
    mutationFn: postToCommunity,
    onMutate: () => AppStatus.set('loading'),
    onSettled: () => AppStatus.set('idle')
  })

  return mut
}
